<template>
  <div>
    <span v-if="hasBrokerResults">
      In addition to our prices (shown above), we
    </span>
    <span v-else>We</span>
    have selected insurance comparison experts Quotezone to help you
    find a better deal on your insurance. They have searched their panel of insurance providers and found
    <strong>{{ quotesQty }} quotes</strong> starting from <strong>£{{ shownResultsCheapestPrice }}.</strong><br><br>
    <u>
      Note that if you purchase  your insurance from a quote below, you will be purchasing directly with
      that insurance provider
    </u>
  </div>
</template>

<script>
export default {
  name: 'results-broker-notification',
  props: {
    hasBrokerResults: {
      type: Boolean,
      default: null,
    },
    quotesQty: {
      type: Number,
      default: null,
    },
    shownResultsCheapestPrice: {
      type: Number,
      default: null,
    },
  },
};

</script>
